/**
 * Google Analytics 4 loader that only runs after explicit consent.
 * The gtag script is injected at runtime — nothing is requested from
 * Google before the visitor opts in.
 */

const GA_ID = process.env.REACT_APP_GA_ID || "G-270NZ37MN3";

let loaded = false;

export function loadAnalytics() {
  if (loaded || typeof window === "undefined") return;
  if (!GA_ID) return;
  loaded = true;

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  function gtag() {
    window.dataLayer.push(arguments);
  }
  window.gtag = gtag;
  gtag("js", new Date());
  // Consent Mode v2 — belt and braces alongside the runtime gate.
  gtag("consent", "default", {
    ad_storage: "denied",
    ad_user_data: "denied",
    ad_personalization: "denied",
    analytics_storage: "granted",
  });
  gtag("config", GA_ID, { anonymize_ip: true });
}

export function trackEvent(name, params = {}) {
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    window.gtag("event", name, params);
  }
}
